var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"z-avatar-v2 inline-block h-9 w-9 rounded-full border border-opacity-20 bg-opacity-20 text-center text-[18px] font-medium uppercase leading-[36px]",class:_vm.getVariantClasses},[_vm._v("\n  "+_vm._s(_vm.username[0])+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }